<template>
  <div class="tab-container" :class="{ 'small-tabs': size === 'small' }">
    <button
      v-for="tab in tabs"
      :key="tab.value"
      class="button-big tab-button"
      :class="{ active: tab.value === tabActiveValue, small: size === 'small' }"
      @click="handleTabClick(tab)"
    >
      {{ tab.label }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { TabItem } from '@/types/components';

defineProps<{
  tabs: TabItem[];
  tabActiveValue: string | number | undefined;
  size?: 'default' | 'small';
}>();

const emit = defineEmits<{ tabClicked: [any] }>();

const handleTabClick = (tab) => {
  emit('tabClicked', tab.value);
};
</script>

<style scoped lang="scss">
.tab-container {
  display: flex;
  width: 100%;
  margin-bottom: 1rem;
  overflow-x: auto;
  flex-shrink: 0;
}

.tab-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: fit-content;
  color: var(--font-dimmer);
  padding: 0.5rem 1.5rem;
  border-bottom: 2px solid var(--border-default);
  word-break: keep-all;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  flex-shrink: 0;
}

.tab-button.active {
  color: var(--font-primary);
  border-bottom: 2px solid var(--border-primary);
}

.tab-button:hover {
  color: var(--font-dim);
  border-bottom: 2px solid var(--border-dark);
}

.tab-button.active:hover {
  color: var(--font-primary);
  border-bottom: 2px solid var(--border-primary);
}

.tab-button.small {
  padding: 0.25rem 1rem;
  width: fit-content;
}

.label.small {
  font-size: $font-size-psmall;
  line-height: $line-height-psmall;
  font-weight: $font-weight-medium;
}
</style>
